import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit-html';
import '@zywave/zui-svg';
import { when } from 'lit-html/directives/when';

class ZuiIcon extends ZuiBaseElement {
  static get properties() {
    return {
      icon: {
        type: String
      }
    };
  }

  constructor() {
    super();
    this.icon = '';
  }

  _renderStyle() {
    return html`
      <style>
        :host{display:inline-block;width:var(--zui-icon-size, 24px);height:var(--zui-icon-size, 24px);line-height:1;fill:currentColor}zui-svg{pointer-events:none;display:inherit;width:inherit;height:inherit;line-height:inherit;fill:inherit}:host(.small){width:var(--zui-icon-size, 16px);height:var(--zui-icon-size, 16px)}:host(.medium){width:var(--zui-icon-size, 36px);height:var(--zui-icon-size, 36px)}:host(.large){width:var(--zui-icon-size, 48px);height:var(--zui-icon-size, 48px)}
      </style>
    `;
  }

  render() {
    return html`
      ${when(this.icon, () => html`
            ${this._renderStyle()} <zui-svg svg-id="${this.icon}"></zui-svg>
          `, () => html`
              <style>
                :host {
                  display: none;
                }
              </style>
            `)}
    `;
  }

}

customElements.define('zui-icon', ZuiIcon);